export default "__VITE_ASSET__2e045872__"